import gql from 'graphql-tag'
import { PRODUCT_REFERENCE_FRAGMENT } from './fragments.graphql'

export const GET_RECENTLY_VIEWED = gql`
  ${PRODUCT_REFERENCE_FRAGMENT}

  query GetRecentlyViewed {
    recentlyViewed {
      products(take: 5) {
        productReferences {
          ...ProductReference
        }
      }
      relatedProducts(take: 4) {
        productReferences {
          ...ProductReference
        }
      }
    }
  }
`
